import React, { useEffect, useState, useRef } from "react";
import { Table, Input } from "antd";
import { getGcaApplications, getMISApplicationsDetails, getMISheaders } from "../auth/services/privateapicalling";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { label } from "yet-another-react-lightbox/*";
import CommonSelect from "../pages/license-registration-form/CommonSelect";
import CommonStatusSelect from "../application/CommonSelect";
import { Option } from "../application/CommonSelect";
import Select from "react-select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";


interface StatusProp {
  status: any[];
  navigateTo?: string;
}



const ApplicationTableMIS: React.FC<StatusProp> = ({ status, navigateTo }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [Selections, setSelections] = useState<boolean>(true);
  const [applicationData, setApplicationData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(5); // Default limit
  const [totalItems, setTotalItems] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [allApplicationData, setAllApplicationData] = useState<any[]>([]);
  
  // const statusOptions = [
  //   {value: "all" , label:"All"},
  //   { value: "pendingAtClerk", label: "Pending At Clerk" },
  //   { value: "pendingAtCo", label: "Pending At Co" },
  //   { value: "pendingAtClerkResubmission", label: "Pending At Clerk Resubmission" },
  //   { value: "pendingAtCoResubmission", label: "Pending At Co Resubmission" },
  //   { value: "pendingAtDr", label: "Pending At Dr" },
  //   { value: "pendingAtDrResubmission", label: "Pending At Dr Resubmission" },
    
  // ];
  const [apiHeaderResponse, setApiHeaderResponse] = useState([]);
  const [selectedHeader, setSelectedHeader] = useState<any>(null);
  const roleIdentifier = useSelector((state: any) => state.auth.userDetails?.Role?.Role_Identifier);

  const [selectedStatus, setSelectedStatus] = useState<Option | null>(null);
  const language = useSelector((state:any)=>state.auth.language);
  const token = useSelector((state: any) => state.auth.token);
  const navigate = useNavigate();
  const debounceTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const onSelectChange = (newSelectedRowKeys: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  useEffect(() => {
  const fetchHeaders = async () => {
    try {
      const response = await getMISheaders(token);

      if (response?.success && response?.data?.length) {
        setApiHeaderResponse(response.data);

        // ✅ SET DEFAULT HEADER (FIRST ONE)
        if (!selectedHeader) {
          setSelectedHeader({
            value: response.data[0].id,
            label: response.data[0].header_name,
          });
        }
      }
    } catch (error) {
    
    }
  };

  fetchHeaders();
}, [token]);


useEffect(() => {
  if (status?.length && !selectedStatus) {
    const rolePendingMap: Record<string, string> = {
      SEC: "pendingAtApmcSecretary",
      JC: "pendingAtClerk",
      COM: "pendingAtCo",
      Dr: "pendingAtDr",
    };

    const preferredValue =
      rolePendingMap[roleIdentifier] ||
      status.find(s => !s.value.includes("all"))?.value;

    const defaultStatus =
      status.find(s => s.value === preferredValue) || status[0];

    setSelectedStatus(defaultStatus);
  }
}, [status, selectedStatus, roleIdentifier]);


  const columns = [
    {
      title: language.application_id,
      dataIndex: "applicationId",
      render: (text: string) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>
      ),
    },
    { title: "Report", dataIndex: "applicantHeader",
      render: (text: string) => (
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id={`tooltip-scheme-${text}`}>
              {text}
            </Tooltip>
          }
        >
          <div
            style={{
              maxWidth: 200,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              cursor: "pointer",
            }}
          >
            {text}
          </div>
        </OverlayTrigger>
      ),
     },
    { title: "Year", dataIndex: "applicantYear" },
    { title: language.apmc, dataIndex: "apmc" },
    {
      title: language.applied_date,
      dataIndex: "appliedDate",
      render: (date: string) => new Date(date).toLocaleDateString("en-GB"), // "DD/MM/YY"
    },
    {
      title: language.application_status,
      dataIndex: "status",
      render: (status: string) => {
        const statusMapping: Record<string, string> = {
              permanentReject: "Permanently Rejected",
          approvedUnsigned: "Approved",
          approve:"Approved",
          reject: "Raised Query",
          pending:"Pending",
          resubmission: "Resubmission",
          draft:"Draft"


        };

        return <span>{statusMapping[status] || status}</span>;
      },
    },
     {
      title: language.action,
      dataIndex: "applicationId",
      render: (text: string, record: any) =>
   
          <h6 className="fw-medium">
            <button
              className="bg-primary rounded text-white px-4 py-2"
              onClick={() =>
    (record.status === "approvedUnsigned" || record.status === "approve")?
    navigate("/mis-preview",{
          state: {
            applicationId: record.applicationId,
            headerId: selectedHeader.value,
            headerName: selectedHeader.label,
          },
          }):
    (roleIdentifier==="SEC" || (navigateTo==="/mis-raise-query" && roleIdentifier==="JC"))
      ? navigate("/mis-raise-query",{
          state: {
            applicationId: record.applicationId,
            headerId: selectedHeader.value,
            headerName: selectedHeader.label,
          },
          })
      : navigate("/mis-approval", {
          state: {
            applicationId: record.applicationId,
            headerId: selectedHeader.value,
            headerName: selectedHeader.label,
          },
        })
  }

            >
              {language.view}
            </button>
          </h6>
        
    },
  ];



  const fetchApplication = async (
    page: number,
    searchApplicationById: string = "",
    limit: number,
    status?: string
  ) => {
    if (!selectedHeader) return;
    setLoading(true);
    try {
     const response = await getMISApplicationsDetails(
          selectedHeader.value,
          limit,
          page,
          status,
          token
        );
      //.log("Fetched Data:", appdata);

      if (response?.success) {
         const formattedData = response.data.map((item: any, index: number) => ({
          key: item.applicationId || index,
          applicationId: item.applicationId,
          applicantHeader: selectedHeader.label,
          applicantYear: item.year,
          apmc: item.apmc || item.apmcName,
          appliedDate: item.createdAt,
          status: item.status,
          // action: item.action || false,
        }));

        setAllApplicationData(formattedData);
        setApplicationData(formattedData);
        setTotalItems(response.totalCount || 0);
      }
    } catch (error) {
      //.error("Error fetching applications:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleHeaderChange = (selectedOption: any) => {
    setSelectedHeader(selectedOption);
    setCurrentPage(1); // Reset to first page when changing header
    setApplicationData([]); // Clear previous data
  };

  const handleSelectChange = (option: Option | null) => {
    setSelectedStatus(option);
    setCurrentPage(1); // Reset to first page when status changes
    fetchApplication(1, searchQuery, limit, option?.value);
  };

// -----

  const handleSearch = (value: string) => {
    setSearchQuery(value);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      if (value.trim() === "") {
        setApplicationData(allApplicationData); // Show all if search is empty
      } else {
        const filtered = allApplicationData.filter((item: any) =>
          item.applicationId?.toString().toLowerCase().includes(value.toLowerCase())
        );
        setApplicationData(filtered);
      }
      setCurrentPage(1); // Reset to page 1
    }, 500);
  };
  const selectOptions = apiHeaderResponse.map((item: any) => ({
    value: item.id,
    label: item.header_name,
  }));

useEffect(() => {
  if (!selectedHeader || !selectedStatus) return;

  fetchApplication(
    currentPage,
    searchQuery,
    limit,
    selectedStatus.value
  );
}, [currentPage, limit, selectedHeader, selectedStatus]);

  return (
    <>
    
      <div className="table-top-data">
        <div className="row p-3">
          <div className="col-sm-12 d-flex justify-content-end">

                     <Select
                options={selectOptions}
                value={selectedHeader}
                onChange={handleHeaderChange}
                placeholder="Select Report"
                isLoading={apiHeaderResponse.length === 0}
                isDisabled={loading}
                className="w-25 me-4"
              />
          <CommonStatusSelect
              options={status}
              value={selectedStatus} // Use value instead of defaultValue
              onChange={handleSelectChange}
              className="w-25 custom-select me-4"
            />

            <Input
              placeholder="Search Application Id..."
              value={searchQuery}
              onChange={(e) => handleSearch(e.target.value)}
              style={{ width: 250 }}
              allowClear
            />
          </div>
        </div>
      </div>

    
      <Table
        className="table datanew dataTable no-footer"
        // rowSelection={Selections ? rowSelection : undefined}
        columns={columns}
        rowKey={"applicationId"}
        rowHoverable={false}
        dataSource={applicationData}
        loading={loading}
        pagination={{
          locale: { items_per_page: "" },
          nextIcon: <i className="ti ti-chevron-right" />,
          prevIcon: <i className="ti ti-chevron-left" />,
          pageSize: limit, 
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30"],
          current: currentPage,
          total: totalItems,
          showTotal: (total, range) =>
            `Showing ${range[0]} - ${range[1]} of ${total} entries`,
          onChange: (page, pageSize) => {
            setCurrentPage(page);
            setLimit(pageSize); 
          },
        }}
      />
    </>
  );
};

export default ApplicationTableMIS;
